import { Fragment } from 'react';
import { FormattedNumberParts } from 'react-intl';

type Props = {
  value: number;
  maximumFractionDigits?: number;
};
export const DecimalScore = ({ value, maximumFractionDigits = 1 }: Props) => (
  <FormattedNumberParts
    value={value}
    maximumFractionDigits={maximumFractionDigits}
  >
    {parts => (
      <>
        {parts.map(({ type, value: v }) => {
          if (type === 'fraction') return <small key={type}>{v}</small>;
          return <Fragment key={type}>{v}</Fragment>;
        })}
      </>
    )}
  </FormattedNumberParts>
);
